import Button from "@mui/material/Button";
import Grid from "@mui/material/Grid2";
import Menu from "@mui/material/Menu";
import { styled } from "@mui/material/styles";
import * as React from "react";
// Moment
import { getRoster } from "@/fetch/fetchRoster";
import DownloadIcon from "@mui/icons-material/Download";
import { IconButton } from "@mui/material";
import Checkbox from "@mui/material/Checkbox";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormGroup from "@mui/material/FormGroup";
import TextField from "@mui/material/TextField";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import moment from "moment";
import "moment/locale/zh-hk";
const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({ theme }) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    padding: 10,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === "light"
        ? "rgb(55, 65, 81)"
        : theme.palette.grey[300],
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
  },
}));

export default function RosterExportPopUp(props) {
  const { setSnackMessage, setSnackOpen, setSnackSeverity } = props;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [isTemplate, setIsTemplate] = React.useState(false);
  const open = Boolean(anchorEl);
  const [selectedDate, setSelectedDate] = React.useState(moment());
  const [isDownloading, setIsDownloading] = React.useState(false);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleOnClick = async () => {
    const yearMonth = moment(selectedDate).format("YYYY-MM");
    try {
      setIsDownloading(true);
      setSnackMessage("下載中...");
      setSnackSeverity("info");
      setSnackOpen(true);
      await getRoster(yearMonth, isTemplate).then((response) => {
        const url = window.URL.createObjectURL(new Blob([response]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Roster ${isTemplate ? "Template" : ""}(${yearMonth}).xlsx`
        );
        document.body.appendChild(link);
        link.click();
        setSnackMessage("下載成功");
        setSnackSeverity("success");
        setIsDownloading(false);
      });
    } catch {
      setSnackMessage("下載失敗");
      setSnackSeverity("error");
      setIsDownloading(false);
    }
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <div>
      <IconButton
        color="inherit"
        id="demo-customized-button"
        aria-controls={open ? "demo-customized-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        disableElevation
        onClick={handleClick}
      >
        <DownloadIcon />
      </IconButton>

      <StyledMenu
        id="demo-customized-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        <DatePicker
          required
          id="startDate"
          name="startDate"
          label="更表日子"
          value={selectedDate}
          views={["year", "month"]}
          onChange={(value) => {
            setSelectedDate(value);
          }}
          renderInput={(params) => (
            <TextField {...params} sx={{ width: "100%" }} />
          )}
        ></DatePicker>
        <Grid container justifyContent="flex-end">
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  value={isTemplate}
                  onClick={(e) => {
                    e.stopPropagation();
                  }}
                  onChange={(event) => {
                    setIsTemplate(event.target.checked);
                  }}
                />
              }
              label="Template"
            />
          </FormGroup>
          <Button disabled={isDownloading} onClick={handleOnClick}>
            下載
          </Button>
        </Grid>
      </StyledMenu>
    </div>
  );
}
